import React from 'react'
import thankyou from '../images/thankyou.svg'

const Thankyou = () => {

  return (
    <div>
      <img src={thankyou} alt="Thank You Page" className='notfound'/>
    </div>
  )
}

export default Thankyou